import { render, staticRenderFns } from "./BusinessRegistryBreakdown.vue?vue&type=template&id=1e59ca54&scoped=true&"
import script from "./BusinessRegistryBreakdown.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistryBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e59ca54",
  null
  
)

export default component.exports